module.exports = __webpack_public_path__ + "img/Smallmail.7a36def0.png";